/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Week_Draft_Row_SubtitleInputs */

const en_us2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 day ready to review · your current plan is untouched`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 day ready to review · your current plan is untouched`);
	return /** @type {LocalizedString} */ (`${i?.count} days ready to review · your current plan is untouched`)
	
};

const pt_br2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia pronto para revisar · seu treino atual continua valendo`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 dia pronto para revisar · seu treino atual continua valendo`);
	return /** @type {LocalizedString} */ (`${i?.count} dias prontos para revisar · seu treino atual continua valendo`)
	
};

const es_419_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 día listo para revisar · tu plan actual sigue vigente`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 día listo para revisar · tu plan actual sigue vigente`);
	return /** @type {LocalizedString} */ (`${i?.count} días listos para revisar · tu plan actual sigue vigente`)
	
};

const pt_pt2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia pronto para rever · o teu plano atual mantém-se`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 dia pronto para rever · o teu plano atual mantém-se`);
	return /** @type {LocalizedString} */ (`${i?.count} dias prontos para rever · o teu plano atual mantém-se`)
	
};

const fr_fr2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 jour prêt à examiner · ton programme actuel reste inchangé`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 jour prêt à examiner · ton programme actuel reste inchangé`);
	return /** @type {LocalizedString} */ (`${i?.count} jours prêts à examiner · ton programme actuel reste inchangé`)
	
};

const de_de2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Tag bereit zur Prüfung · dein aktueller Plan bleibt unverändert`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Tag bereit zur Prüfung · dein aktueller Plan bleibt unverändert`);
	return /** @type {LocalizedString} */ (`${i?.count} Tage bereit zur Prüfung · dein aktueller Plan bleibt unverändert`)
	
};

const it_it2_week_draft_row_subtitle = /** @type {(inputs: Week_Draft_Row_SubtitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 giorno pronto da rivedere · la tua scheda attuale resta invariata`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 giorno pronto da rivedere · la tua scheda attuale resta invariata`);
	return /** @type {LocalizedString} */ (`${i?.count} giorni pronti da rivedere · la tua scheda attuale resta invariata`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 day ready to review · your current plan is untouched" |
* | "-1" | "1 day ready to review · your current plan is untouched" |
* | * | "{count} days ready to review · your current plan is untouched" |
*
* @param {Week_Draft_Row_SubtitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const week_draft_row_subtitle = /** @type {((inputs: Week_Draft_Row_SubtitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Draft_Row_SubtitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_week_draft_row_subtitle(inputs)
	if (locale === "es-419") return es_419_week_draft_row_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_week_draft_row_subtitle(inputs)
	if (locale === "fr-FR") return fr_fr2_week_draft_row_subtitle(inputs)
	if (locale === "de-DE") return de_de2_week_draft_row_subtitle(inputs)
	if (locale === "it-IT") return it_it2_week_draft_row_subtitle(inputs)
	return en_us2_week_draft_row_subtitle(inputs)
});
export { week_draft_row_subtitle as "week.draft_row_subtitle" }